var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"proPage proPage--oneAction"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"splash splash--pro"},[_c('img',{attrs:{"src":"/images/splash/avatar_sorry.png","alt":"Sorry"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.trans('failed_pro_upgrade')))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }